import React, { useEffect, useState, useRef } from 'react';
import "../Styles/Register.css";
import Img from "../Assets/icons/VELOXLogo.png";
import * as yup from "yup";
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import countries from '../Assets/countries';
import { useTranslation } from 'react-i18next';
import MDUserProfileHeader from './MDUserProfileHeader';

function MDRequest({ logado = false }) {
  const navigate = useNavigate();
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const yubikeyInputRef = useRef(null);
  const dialogContentRef = useRef(null);
  const { t } = useTranslation();

  const handleRequestYubiKey = (values) => {
    const countrySelect = document.querySelector('.country');
    const stateSelect = document.querySelector('.state');
    const citySelect = document.querySelector('.city');

    const selectedCountry = countrySelect.options[countrySelect.selectedIndex].text;
    const selectedState = stateSelect.options[stateSelect.selectedIndex].text;
    const selectedCity = citySelect.options[citySelect.selectedIndex].text;

    const countryCode = document.querySelector('.country-code-box strong').innerText;
    const fullPhoneNumber = `${countryCode}-${values.phone}`;

    const email = localStorage.getItem('userEmail');
    Axios.post(`/request_yubikey`, {
      email: email,
      quantity: values.quantity,
      phone: fullPhoneNumber,
      country: selectedCountry,
      state: selectedState,
      city: selectedCity,
      address: values.address,
      postalcode: values.postalcode,
    }).then((response) => {
      if (response.data.success) {
        toast.success("VELOX CLOUD Keys request submitted successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      else {
        toast.error(`${response.data.msg}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }).catch((error) => {
      toast.error("Register error, please try again!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Register error:', error);
    });
  };

  const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
  };

  const [stateSelectDisabled, setStateSelectDisabled] = useState(true);
  const [citySelectDisabled, setCitySelectDisabled] = useState(true);

  const loadStates = () => {
    const stateSelect = document.querySelector('.state');
    const citySelect = document.querySelector('.city');
    const countrySelect = document.querySelector('.country');
    const selectedCountryCode = countrySelect.value;

    setStateSelectDisabled(false);
    setCitySelectDisabled(true);

    stateSelect.innerHTML = '<option value="">Select State</option>';
    citySelect.innerHTML = '<option value="">Select City</option>';

    fetch(`${config.cUrl}/${selectedCountryCode}/states`, { headers: { "X-CSCAPI-KEY": config.ckey } })
      .then(response => response.json())
      .then(data => {
        data.forEach(state => {
          const option = document.createElement('option');
          option.value = state.iso2;
          option.textContent = state.name;
          stateSelect.appendChild(option);
        });
      })
      .catch(error => console.error('Error loading states:', error));
  };

  const loadCities = () => {
    const citySelect = document.querySelector('.city');
    const countrySelect = document.querySelector('.country');
    const stateSelect = document.querySelector('.state');
    const selectedCountryCode = countrySelect.value;
    const selectedStateCode = stateSelect.value;

    setCitySelectDisabled(false);

    citySelect.innerHTML = '<option value="">Select City</option>';

    fetch(`${config.cUrl}/${selectedCountryCode}/states/${selectedStateCode}/cities`, { headers: { "X-CSCAPI-KEY": config.ckey } })
      .then(response => response.json())
      .then(data => {
        data.forEach(city => {
          const option = document.createElement('option');
          option.value = city.iso2;
          option.textContent = city.name;
          citySelect.appendChild(option);
        });
      })
      .catch(error => console.error('Error loading cities:', error));
  };

  useEffect(() => {
    const countrySelect = document.querySelector('.country');

    fetch(config.cUrl, { headers: { "X-CSCAPI-KEY": config.ckey } })
      .then(response => response.json())
      .then(data => {
        data.forEach(country => {
          const option = document.createElement('option');
          option.value = country.iso2;
          option.textContent = country.name;
          countrySelect.appendChild(option);
        });
      })
      .catch(error => console.error('Error loading countries:', error));
  }, [config.cUrl, config.ckey]);

  useEffect(() => {
    const selectBox = document.querySelector('.options');
    const searchBox = document.querySelector('.search-box');
    const countryCodeBox = document.querySelector('.country-code-box');
    let options = null;

    for (const country of countries) {
      const option = `
        <li class="option">
          <div>
            <span class="iconify" data-icon="flag:${country.code.toLowerCase()}-4x3"></span>
            <span class="country-name">${country.name}</span>
          </div>
          <strong>+${country.phone}</strong>
        </li>`;
      selectBox.querySelector('ol').insertAdjacentHTML('beforeend', option);
      options = document.querySelectorAll('.option');
    }

    function selectOption(event) {
      const selectedCountry = event.currentTarget;
      const iconElement = selectedCountry.querySelector('.iconify');
      const phoneCodeElement = selectedCountry.querySelector('strong');

      if (iconElement && phoneCodeElement) {
        const icon = iconElement.cloneNode(true);
        const phoneCode = phoneCodeElement.cloneNode(true);

        countryCodeBox.innerHTML = '';
        countryCodeBox.append(icon, phoneCode);

        selectBox.classList.remove('active');
        searchBox.value = '';
        selectBox.querySelectorAll('.hide').forEach(el => el.classList.remove('hide'));
      }
    }

    function searchCountry() {
      const searchQuery = searchBox.value.toLowerCase();
      for (const option of options) {
        const isMatched = option.querySelector('.country-name').innerText.toLowerCase().includes(searchQuery);
        option.classList.toggle('hide', !isMatched);
      }
    }

    countryCodeBox.addEventListener('click', (e) => {
      e.stopPropagation();
      selectBox.classList.toggle('active');
    });

    const phoneNumberField = document.querySelector('input[type="tel"]');
    phoneNumberField.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    options.forEach(option => option.addEventListener('click', selectOption));
    searchBox.addEventListener('input', searchCountry);

    document.addEventListener('click', (e) => {
      if (!selectBox.contains(e.target) && !countryCodeBox.contains(e.target)) {
        selectBox.classList.remove('active');
      }
    });

    return () => {
      countryCodeBox.removeEventListener('click', (e) => {
        e.stopPropagation();
        selectBox.classList.toggle('active');
      });

      options.forEach(option => option.removeEventListener('click', selectOption));
      searchBox.removeEventListener('input', searchCountry);
      phoneNumberField.removeEventListener('click', (e) => {
        e.stopPropagation();
      });

      document.removeEventListener('click', (e) => {
        if (!selectBox.contains(e.target) && !countryCodeBox.contains(e.target)) {
          selectBox.classList.remove('active');
        }
      });
    };
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const validationsRegister = yup.object().shape({
    quantity:yup
      .number()
      .typeError("Quantity must be a number")
      .positive("Quantity must be a positive number")
      .integer("Quantity must be an integer")
      .required("Quantity is mandatory"),
    phone: yup
      .string()
      .matches(/^[0-9]+$/, "Phone number should only contain numbers")
      .required("Phone number is mandatory"),
    address: yup
      .string()
      .required("Address is mandatory"),
  });

  return (
    <div>
      <MDUserProfileHeader isAdmin={true} />
      <div className='register-card'>
        <h1 className='register'>{t('Request VELOX CLOUD Key')}</h1>
        <Formik
          initialValues={{
            quantity: '',
            address: '',
            postalcode: '',
          }}
          onSubmit={handleRequestYubiKey}
          validationSchema={validationsRegister}
        >
          {({ values }) => (
            <Form className="register-form">
              <div className="register-form-group">
                <Field name="quantity" type="text" className="register-form-quantity-field" placeholder="VELOX CLOUD Key Quantity" />
              </div>

              <div className="register-form-group register-form-phone">
                <div className="select-box">
                  <div className="selected-option">
                    <div className="country-code-box">
                      <span className="iconify" data-icon="flag:ae-4x3"></span>
                      <strong>+971</strong>
                    </div>
                    <Field name="phone" type="tel" placeholder="Phone Number" className="form-field" />
                  </div>
                  <div className="options"> {/* Dropdown list */}
                    <input type="text" className="search-box" placeholder="Search Country Name" />
                    <ol></ol>
                  </div>
                </div>
                <ErrorMessage component="span" name="phoneNumber" className="register-form-error" />
              </div>

              <div>
                <select className="form-select country" aria-label="Country select" onChange={loadStates}>
                  <option selected>Select Country</option>
                </select>
                <select className="form-select state" aria-label="State select" onChange={loadCities} disabled={stateSelectDisabled}>
                  <option selected>Select State</option>
                </select>
                <select className="form-select city" aria-label="City select" disabled={citySelectDisabled}>
                  <option selected>Select City</option>
                </select>
              </div>

              <div className="register-form-group">
                <Field as="textarea" name="address" rows="3" className="register-form-address-field" placeholder="Detail address" />
                <ErrorMessage component="span" name="address" className="register-form-address-error" />
              </div>

              <div className="register-form-group">
                <Field name="postalcode" type="text" className="register-form-postal-field" placeholder="Postal code (optional)" />
              </div>

              <button className="register-yubikey-button" type="submit" >
                Submit Request
              </button>
            </Form>
          )}
        </Formik>
      </div>

      <ToastContainer position='top-right' />
    </div>
  );
}

export default MDRequest;
